export default {"src":"/_next/static/media/filter-icon.48b8b6e6.svg","height":17,"width":24};